module.exports = __webpack_public_path__ + "img/us-pro-desc.546e295a.png";